<template>
    <v-sheet dark tile>
        <v-content>
            <v-row dense>
                <v-col align="center">
                    <span class="display-1 color-primario">
                        <h2>Comunicate con Nosotros</h2>
                    </span>
                </v-col>
            </v-row>
            <v-row>
                <!--<v-col align="center">
                    <span>
                        Tenemos a tu disposición los siguientes canales
                    </span>
                </v-col>
            </v-row>
            <v-row no-gutters>
                    <v-col cols="12"  align="center">
                        <span>
                            Tel: 322 1086960 
                        </span>
                    </v-col>
                    <v-col cols="12" align="center">
                        <span>
                            Tel: 322 728 30 68 
                        </span>
                    </v-col>-->
                    <v-col cols="12" align="center">
                        <span>
                            Email: info@wallaudit.com
                        </span>
                    </v-col>
            </v-row>
            <!--<v-row>
                <v-col align="center">
                    <span>
                        <h3>O mejor aún, ven a visitarnos!!</h3>
                    </span>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col align="center">
                    <p>
                        Nos encanta recibir a nuestros clientes, ¡¡Ven en cualquier momento de Lunes a Viernes de 9:00 a 16:00
                    </p>
                </v-col>
            </v-row>
            <v-row no-gutters>
                <v-col align="center">
                    <p>
                        Brasil 1410 B, Col 5 de Diciembre, Puerto Vallarta, Jalisco
                    </p>
                </v-col>
            </v-row>-->
        </v-content>
    </v-sheet>
</template>

<script>
export default {

}
</script>

<style>
.color-primario{
    color: white;
}
</style>